// extracted by mini-css-extract-plugin
module.exports = {"button":"button-3vl53","text":"text-3u00g","img":"img-2WDNC","instr":"instr-2M-Kn"};